export interface INhanVien{
    IdTinhThanh:number,
    Id:number,
    TaiKhoan:string,
    HoTen:string,
    IdDonVi:number,
    IdChucVu:number,
    NgaySinh:string,
    GioiTinh:number,
    Cmnd:string,
    DienThoai:string,
    Email:string,
    DangNhapLanCuoi:any,
    TrangThai:number,
    hasAccount:boolean,
    TenChucVu:string,
    Avatar:string,
    Otp:boolean, 
    SMS:boolean,
    Ids: string;
    IsXPHC: number;
}

export class NhanVien implements INhanVien{
    IdTinhThanh:number=0;
    Id:number=0;
    TaiKhoan:string='';
    HoTen:string='';
    IdDonVi:number=0;
    IdChucVu:number=0;
    NgaySinh:string="";
    GioiTinh:number=0;
    Cmnd:string='';
    DienThoai:string='';
    Email:string='';
    DangNhapLanCuoi:any='';
    TrangThai:number=0;    
    hasAccount:boolean=false;
    TenChucVu:string='';
    Avatar:string='';
    Otp:boolean=false;
    SMS:boolean=true;
    Ids: string = "";
    IsXPHC: number = 0;
}
export class SearchNV{
    keyword:string = "";
    maxSize:number = 3;    
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/nhan-vien/nhan-vien.ts